import React from 'react';
import MedicalPassportCheckbox from '../../components/MedicalPassportCheckbox';
import MedicalPassportField from '../../components/MedicalPassportField';
import MedicalPassportTextArea from '../../components/MedicalPassportTextArea';

const Page3 = ({ hospitalName }) => {
  return (
    <div id="page3-restore-summary" className="page">
      {/* Header Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: 0 }}>{(hospitalName || '').toUpperCase()}</h3>
        </div>
        <div style={{ flex: 1, textAlign: 'right' }}>
          <h3 style={{ margin: 0 }}>HAND OFF TOOL</h3>
        </div>
      </div>

      {/* Main Table */}
      <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', fontSize: '12px' }}>
        <tbody>
          {/* PAT Row */}
          <tr>
            <td
              style={{
                width: '12%',
                border: '1px solid black',
                padding: '15px',
                fontWeight: 'bold',
                textAlign: 'center',
                verticalAlign: 'top',
                fontSize: '14px',
              }}
            >
              PAT
            </td>
            <td style={{ border: '1px solid black', padding: '15px', verticalAlign: 'top' }}>
              <div style={{ marginBottom: '1rem' }}>
                <strong>Notes:</strong>
                <MedicalPassportTextArea
                  name="restoreSummary.pat.notes"
                  rows={3}
                  style={{ width: '100%', fontSize: '12px', marginTop: '0.5rem' }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <strong>Meds to take DOS:</strong>
                <MedicalPassportTextArea
                  name="restoreSummary.pat.medsToTakeDOS"
                  rows={5}
                  style={{ width: '100%', fontSize: '12px', marginTop: '0.5rem' }}
                />
              </div>

              <div style={{ marginBottom: '0.5rem' }}>
                <MedicalPassportCheckbox
                  label="History Reviewed with Patient"
                  name="restoreSummary.pat.historyReviewed"
                />
              </div>

              <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <span>PAT RN Signature:</span>
                <MedicalPassportField name="restoreSummary.pat.rnSignature" style={{ flex: 1, fontSize: '12px' }} />
                <span>Date/Time</span>
                <MedicalPassportField name="restoreSummary.pat.dateTime" style={{ width: '150px', fontSize: '12px' }} />
              </div>
            </td>
          </tr>

          {/* PREOP on DOS Row */}
          <tr>
            <td
              style={{
                border: '1px solid black',
                padding: '15px',
                fontWeight: 'bold',
                textAlign: 'center',
                verticalAlign: 'top',
                fontSize: '14px',
              }}
            >
              PREOP on DOS
            </td>
            <td style={{ border: '1px solid black', padding: '15px', verticalAlign: 'top' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Notes:</strong>
                <MedicalPassportCheckbox label="No Changes" name="restoreSummary.preopOnDos.noChanges" />
              </div>
              <MedicalPassportTextArea
                name="restoreSummary.preopOnDos.notes"
                rows={3}
                style={{ width: '100%', fontSize: '12px', marginTop: '0.5rem' }}
              />

              <div style={{ marginBottom: '0.3rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MedicalPassportCheckbox
                  label="Jewelry left in place"
                  name="restoreSummary.preopOnDos.jewelryLeftInPlace"
                />
                <MedicalPassportField
                  name="restoreSummary.preopOnDos.jewelryNotes"
                  style={{ flex: 1, fontSize: '12px' }}
                />
              </div>

              <div style={{ marginBottom: '0.3rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MedicalPassportCheckbox
                  label="Skin assessment notes"
                  name="restoreSummary.preopOnDos.skinAssessmentNotes"
                />
                <MedicalPassportField
                  name="restoreSummary.preopOnDos.skinAssessmentNotesText"
                  style={{ flex: 1, fontSize: '12px' }}
                />
              </div>

              <div style={{ marginBottom: '0.3rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MedicalPassportCheckbox label="Vanco started @" name="restoreSummary.preopOnDos.vancoStarted" />
                <MedicalPassportField
                  name="restoreSummary.preopOnDos.vancoTime"
                  style={{ width: '100px', fontSize: '12px' }}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <MedicalPassportCheckbox
                  label="Unable to place spinal"
                  name="restoreSummary.preopOnDos.unableToPlaceSpinal"
                />
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <span>RN Initials</span>
                  <MedicalPassportField
                    name="restoreSummary.preopOnDos.rnInitials"
                    style={{ width: '80px', fontSize: '12px' }}
                  />
                </div>
              </div>
            </td>
          </tr>

          {/* INTRAOP on DOS Row */}
          <tr>
            <td
              style={{
                border: '1px solid black',
                padding: '15px',
                fontWeight: 'bold',
                textAlign: 'center',
                verticalAlign: 'top',
                fontSize: '14px',
              }}
            >
              INTRAOP on DOS
            </td>
            <td style={{ border: '1px solid black', padding: '15px', verticalAlign: 'top' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Notes:</strong>
                <MedicalPassportCheckbox label="No Changes" name="restoreSummary.intraopOnDos.noChanges" />
              </div>
              <MedicalPassportTextArea
                name="restoreSummary.intraopOnDos.notes"
                rows={3}
                style={{ width: '100%', fontSize: '12px', marginTop: '0.5rem' }}
              />
              <div style={{ marginBottom: '0.3rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MedicalPassportCheckbox
                  label="Changes to skin assessment"
                  name="restoreSummary.intraopOnDos.changesToSkinAssessment"
                />
                <MedicalPassportField
                  name="restoreSummary.intraopOnDos.changesToSkinAssessmentText"
                  style={{ flex: 1, fontSize: '12px' }}
                />
              </div>

              <div style={{ marginBottom: '0.3rem' }}>
                <MedicalPassportCheckbox
                  label="Total Knee- ACE bandage"
                  name="restoreSummary.intraopOnDos.totalKneeAceBandage"
                />
              </div>

              <div style={{ marginBottom: '0.3rem' }}>
                <MedicalPassportCheckbox
                  label="Exparel given/ bracelet applied"
                  name="restoreSummary.intraopOnDos.exparelGiven"
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '2rem' }}>
                  <MedicalPassportCheckbox label="Void in OR" name="restoreSummary.intraopOnDos.voidInOr" />
                  <MedicalPassportCheckbox label="Converted to GA" name="restoreSummary.intraopOnDos.convertedToGa" />
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <span>RN Initials</span>
                  <MedicalPassportField
                    name="restoreSummary.intraopOnDos.rnInitials"
                    style={{ width: '80px', fontSize: '12px' }}
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Patient Label Box */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
        <div
          style={{
            border: '1px solid black',
            padding: '0.5rem 1rem',
            width: '150px',
            minHeight: '60px',
          }}
        >
          <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '10px' }}>Patient Label</div>
        </div>
      </div>
    </div>
  );
};

export default Page3;
